import { render, staticRenderFns } from "./KnowledgeBaseManager.vue?vue&type=template&id=fa8ce16a&scoped=true"
import script from "./KnowledgeBaseManager.vue?vue&type=script&lang=js"
export * from "./KnowledgeBaseManager.vue?vue&type=script&lang=js"
import style0 from "./KnowledgeBaseManager.vue?vue&type=style&index=0&id=fa8ce16a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa8ce16a",
  null
  
)

export default component.exports